var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgImage"},[_c('ContentHeader',{staticClass:"mainHeader"}),_c('LandingPageNew',{staticClass:"mainBody"}),_c('ContentFooter',{staticClass:"mainFooter"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }